<template>
  <div class="mt-5">
    <div class="grid gap-1 grid-cols-3 md:gap-8 md:grid-cols-3">
      <div class="bg-white border inline-block align-middle">
        <div class="w-full text-center bg-green-800 text-gray-200">
          <feather size="100" class="h-full " type="pen-tool"/>
        </div>
        <div class="p-2">
          <router-link :to="{name: 'splash_page_details', params: {pageId: pageId}}"
                       class="tab tab-explore block font-semibold mt-1"> Drag & Drop editor
          </router-link>
          <small>Use built-in drag and drop builder to design your page</small>
          <div class="my-2">
            <button @click="chooseBuilder(1)"
                    class="border rounded text-xs mr-2 border-green-500 text-green-500 p-1 hover:bg-green-500 hover:text-white">
              Select
            </button>
          </div>
        </div>
      </div>
      <div class="bg-white border inline-block">
        <div class="w-full text-center  bg-teal-800 text-gray-200">
          <feather size="100" class="h-full" type="code"/>
        </div>
        <div class="p-2">
          <div :to="{name: 'splash_page_details', params: {pageId: pageId}}"
               class="tab tab-explore block font-semibold mt-1"> Code editor
          </div>
          <small>Use our code editor to create your page.</small>

          <div class="my-2">
            <button @click="chooseBuilder(2)"
                    class="border rounded text-xs mr-2 border-teal-500 text-teal-500 p-1 hover:bg-teal-500 hover:text-white">
              Select
            </button>
          </div>
        </div>
      </div>
      <div class="bg-white border inline-block">
        <div class="w-full text-center bg-blue-800 text-gray-200">
          <feather size="100" class="h-full" type="copy"/>
        </div>
        <div class="p-2">
          <div :to="{name: 'splash_page_details', params: {pageId: pageId}}"
               class="tab tab-explore block font-semibold mt-1"> Clone template
          </div>
          <small>Clone a pre-designed templates. There is option of changing few configurations</small>

          <div class="my-2">
            <button @click="selectTemplate = !selectTemplate"
                    class="border rounded text-xs mr-2 border-blue-500 text-blue-500 p-1 hover:bg-blue-500 hover:text-white">
              Templates
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectTemplate">
      <div class="text-center my-4">select a template below to proceed</div>
      <div class="grid gap-1 md:gap-2 grid-cols-2 md:grid-cols-4">
        <div v-for="page in pages" :key="page.id" class="bg-white border inline-block align-middle">
          <a target="_blank" :href="page.page_url">
            <img :src="page.screenshot" class="inline-block align-middle w-full">
          </a>
          <div class="p-2">
            <router-link :to="{name: 'splash_page_details', params: {pageId: page.id}}"
                         class="tab tab-explore block font-semibold mt-1"> {{ page.name }}
            </router-link>
            <small>{{ page.description }}</small>
            <div class="mb-2">
              <div class="flex mt-2 bottom-0">
                <button @click="cloneTemplate(page.id)"
                        class="border rounded text-xs mr-2 border-blue-500 text-blue-500 p-1 hover:bg-blue-500 hover:text-white">
                  Clone
                </button>
                <router-link
                    class="border rounded text-xs mr-2 border-teal-500 text-teal-500 p-1 hover:bg-teal-500 hover:text-white"
                    :to="{name: 'splash_page_details', params: {pageId: page.id}}">Options
                </router-link>
                <a target="_blank"
                   class="border rounded text-xs mr-2 border-green-500 text-green-500 p-1 hover:bg-green-500 hover:text-white"
                   :href="page.page_url + '?preview=true'">Preview</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SplashPageService from "../services/splashPage.service";

export default {
  name: "SetupPageComponent",
  components: {},
  props: {
    pageId: String
  },
  data() {
    return {
      selectTemplate: false,
      pages: [],
      errors: [],
      messages: [],
    }
  },
  mounted() {
    this.getSplashPages();
    this.$root.$emit("alert_info", ["Use options below to complete your page set up"])
  },

  watch: {
    errors: function (errors) {
      this.$root.$emit('alert_error', errors);
    },
    messages: function (messages) {
      this.$root.$emit('alert_success', messages);
    }
  },
  methods: {
    getSplashPages() {
      SplashPageService.getAll("template=true").then(response => {
        this.pages = response.pages;
      });
    },

    chooseBuilder(builder) {
      this.errors = [];
      SplashPageService.update(this.pageId, {type: builder}).then(response => {
        this.$root.$emit('refresh_page', true);
        this.$root.$emit('alert_success', [response.message]);
      })
    },
    cloneTemplate(template) {
      this.errors = [];
      SplashPageService.cloneTemplate(this.pageId, template)
          .then(response => {
            if (response.page != null) {
              this.$root.$emit('refresh_page', true);
              this.$root.$emit('alert_success', [response.message]);
            } else {
              this.errors.push(response.message)
            }
          })
    }
  }
}
</script>

<style scoped>

</style>